import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ta/search')({
  ssr: false,
});
